<template>
  <div>
    <img src="@/assets/images/404@2x.png" alt="">
    <span @click="toGoBack">返回首页</span>
  </div>
</template>

<script>
  export default {
    name: "NotFound",
    methods: {
      toGoBack() {
        this.$router.push('/');
      }
    }
  }
</script>

<style scoped>
  img {
    margin: 6% auto 0;
    display: block;
  }

  span {
    width: 180px;
    height: 50px;
    border: 1px solid #CF121C;
    border-radius: 25px;
    font-size: 24px;
    color: #CF121C;
    line-height: 48px;
    display: block;
    text-align: center;
    cursor: pointer;
    transition: .3s;
    margin: 3.5% auto 0;
  }

  span:hover {
    background: #CF121C;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/NotFound/NotFound.vue